const DigitalSignatureProviders = {
    QuoVadis: '1',
    ElectronicSignature: '3',
    QuoVadisV2: '4',
    Skribble: '5',
};
export default DigitalSignatureProviders;
